var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('Intro',{attrs:{"data-aos":"fade","data-aos-duration":"3000"}}),_c('Story',{ref:"story"}),_c('Benefits')],1)}
var staticRenderFns = []

export { render, staticRenderFns }